import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.isFormSubmitting = false;
    this.values = new Map();

    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onBeforeUnload = this.onBeforeUnload.bind(this);

    this.trackInputs();
    this.element.addEventListener("submit", this.onSubmit);
    window.addEventListener("beforeunload", this.onBeforeUnload);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.onSubmit);
    this.inputs?.forEach((input) => input.removeEventListener("change", this.onInputChange));
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  }

  trackInputs() {
    this.inputs = this.element.querySelectorAll("input, select, textarea");
    this.inputs.forEach((input) => {
      const name = input.getAttribute("name");
      if (!name) return;

      this.values.set(name, { original: input.value, current: input.value });
      input.addEventListener("change", this.onInputChange);
    });
  }

  onInputChange(event) {
    const input = event.currentTarget;
    const name = input.getAttribute("name");
    if (!name || !this.values.has(name)) return;

    const state = this.values.get(name);
    state.current = input.value;
    this.values.set(name, state);
  }

  onSubmit() {
    this.isFormSubmitting = true;
  }

  onBeforeUnload(event) {
    if (this.isFormSubmitting || !this.isDirty()) return;

    event.preventDefault();
    event.returnValue = "";
  }

  isDirty() {
    return Array.from(this.values.values()).some((state) => state.original !== state.current);
  }
}
